import { formatDistanceToNow } from 'date-fns'

import { deviceLiveness } from '@/lib/device-telemetry'
import { cn } from '@/lib/utils'

const DOT_CLASS = {
  online: 'bg-green-500',
  'daemon-down': 'bg-amber-500',
  offline: 'bg-red-400',
  'never-seen': 'bg-muted-foreground/40',
} as const

const STATUS_LABEL = {
  online: 'Online',
  'daemon-down': 'Daemon down',
  offline: 'Offline',
  'never-seen': 'Never seen',
} as const

export function DeviceOnlineIndicator({
  lastHeartbeatAt,
  userAgentHeartbeatAt,
  showLabel = true,
}: {
  lastHeartbeatAt: string | null | undefined
  userAgentHeartbeatAt?: string | null | undefined
  showLabel?: boolean
}) {
  const liveness = deviceLiveness(lastHeartbeatAt, userAgentHeartbeatAt)
  const status = STATUS_LABEL[liveness]
  const label =
    lastHeartbeatAt && liveness !== 'never-seen'
      ? `${status} — ${formatDistanceToNow(new Date(lastHeartbeatAt), {
          addSuffix: true,
        })}`
      : status

  return (
    <span className="flex items-center gap-1.5">
      <span
        className={cn('h-2 w-2 shrink-0 rounded-full', DOT_CLASS[liveness])}
        {...(showLabel ? { 'aria-hidden': true } : { role: 'img', 'aria-label': status })}
      />
      {showLabel && <span className="text-muted-foreground text-xs">{label}</span>}
    </span>
  )
}
